<article class="container">
  <div class="number-container">
    <div class="number">404</div>
    <div class="number fill">404</div>
  </div>
  <figure class="image-wrapper">
    <img src="svgs/icons/wire.svg" alt="" class="image" />
  </figure>
  <div class="texts-wrapper">
    <div class="texts">
      <p class="title">Page Not Found</p>
      <p class="small">
        Sorry, the page you’re looking for does not exist or has been moved
      </p>
      <p class="small">please go back to the Home page</p>
    </div>
  </div>

  <div class="button-wrapper">
    <button class="btn" routerLink="/">Go back Home</button>
  </div>
</article>
